<template>
    <dialog ref="dialog" id="cst-survey-modal" key="card.id" @close="closeModal">
        <component key="card.id" :is="card.type" :content="card.content"></component>
    </dialog>
</template>

<script>
  import CardFeedbackComment from '@/components/CardFeedbackComment'
  import CardFeedbackTopic from '@/components/CardFeedbackTopic'

  export default {
    data () {
      return {
        card: false
      }
    },
    components: {
      CardFeedbackComment, CardFeedbackTopic
    },
    created: function () {
      eventHub.$on('close-modal', this.hideModal)
      eventHub.$on('show-modal', this.showModal)
    },

    methods: {
      showModal: function (modalData) {
        if (!this.card) {
          this.$refs.dialog.showModal()
        }
        this.card = modalData
      },
      hideModal: function () {        
        this.$refs.dialog.close()
      },
      closeModal: function() {
        this.card = false
      }
    }
  }
</script>

<style lang="less" scoped>
    @import '../_theme';

  #cst-survey-modal {
    margin-top: 20vh;
    padding: 0px;
    width: 650px;
    border: 1px solid @border-color;
    &::backdrop {
      background-color: rgba(0,0,0,0.5);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/AppModal.vue